import React from 'react'
import { RouteComponentProps, Route } from 'react-router-dom'

import { RouteProps } from './types'

type Props = {
  component: any
} & RouteComponentProps &
  Omit<RouteProps, 'component'>

export const RouteRenderer = ({
  component: Component,
  nested,
  ...props
}: Props) => {
  return (
    <>
      <Component {...props} />

      {nested?.map((route, index) => (
        <Route key={index} {...route} />
      ))}
    </>
  )
}
